module.exports = __webpack_public_path__ + "static/media/18.b2cde1e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/18.jpg
// module id = 387
// module chunks = 0